var render = function (_h,_vm) {var _c=_vm._c;return _c('font-awesome-icon',{attrs:{"icon":_vm.props.iconMap[_vm.props.name],"fixed-width":!_vm.props.inline,"spin":_vm.props.spin}})}
var staticRenderFns = []

export { render, staticRenderFns }